import { AxiosInstance } from "axios";

export const AgendesService = (axiosInstance: AxiosInstance) => {
  const apiBaseUrlMasterdata = "api/masterdata";
  const apiBaseUrlAgenda = "api/agenda";
  const apiBaseUrlUser = "api/user";
  const apiBaseUrlImage = "api/image";
  const apiBaseUrlProfile = "api/profile";

  return {
    getMasterdataAgenda: async () => {
      return await axiosInstance.get(`${apiBaseUrlMasterdata}/agenda`).then((result) => result.data);
    },
    getAgenda: async (agendaId?: string) => {
      return await axiosInstance.get(`${apiBaseUrlAgenda}/${agendaId}`).then((result) => result.data);
    },
    getUserById: async (userId?: string) => {
      return await axiosInstance.get(`${apiBaseUrlProfile}/${userId}`).then((result) => result.data);
    },
    createByAgenda: async (
      agendaId?: string,
      databody?: {
        fullName: string;
        email: string;
        company: string;
        department: string;
        position: string;
        phone: string;
      }
    ) => {
      return await axiosInstance.post(`${apiBaseUrlUser}/${agendaId}`, databody).then((result) => result.data);
    },
    createByAgendaWalkin: async (
      agendaId?: string,
      databody?: {
        fullName: string;
        email: string;
        company: string;
        department: string;
        position: string;
        phone: string;
      }
    ) => {
      return await axiosInstance.post(`${apiBaseUrlUser}/walkin/${agendaId}`, databody).then((result) => result.data);
    },
    resgister: async (agendaid?: string, data?: any) => {
      return await axiosInstance.post(`${apiBaseUrlUser}/resgister/${agendaid}`, data).then((result) => result.data);
    },
    uploadImage: async (userId?: string, formData?: any) => {
      return await axiosInstance
        .post(`${apiBaseUrlImage}/upload/${userId}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((result) => result.data);
    },
    validateIdCard: async (taxpayer?: string) => {
      return await axiosInstance.post(`${apiBaseUrlUser}/validate-idcard/${taxpayer}`).then((result) => result.data);
    },
    validatePassword: async (agendaid: string, password: string) => {
      const data = {
        password: password,
      };
      return await axiosInstance.post(`${apiBaseUrlAgenda}/validate-password/${agendaid}`, data).then((result) => result.data.message);
    },
  };
};
